import type { ProductCardTranslations } from "./pl";

export const de: ProductCardTranslations = {
  addToCart: "In den Warenkorb",
  cartComingSoon:
    "Der Warenkorb wird im nächsten Migrationsschritt verfügbar sein.",
  priceFrom: "Ab:",
  badges: {
    bestseller: "Bestseller",
    recomended: "Empfohlen",
    new: "Neu",
  },
  status: {
    temporary_unavailable: "Vorübergehend nicht verfügbar.",
    archive: "Archiviert.",
    in_set: "Nur als Teil eines Sets erhältlich.",
  },
  formatPrice: (value: number, currency: string): string => {
    const rounded = (Math.round(value * 100) / 100).toFixed(2).replace(".", ",");
    return currency ? `${rounded} ${currency}` : rounded;
  },
  lowestPrice: (formatted: string): string =>
    `Niedrigster Preis der letzten 30 Tage: ${formatted}`,
};
